import * as React from 'react';
import { connect } from 'react-redux';
import * as ReactDOM from 'react-dom';
import { Route, Link, withRouter } from 'react-router-dom';
import { bindActionCreators } from "redux";


class HomeSections extends React.Component<any, any> {

    render() {
        let sectionOneContent;
        let sectionTwoContent;

        if (this.props.homeSettings && !this.props.isLoading) {
            sectionOneContent = (<div className="container">
                <h1 className="mb-2">{this.props.homeSettings.sectionOneText.split('<br />').map((text, index) => {
                    return index == 0 ? <span>{text}</span> : <span><br />{text}</span>
                })}</h1>
                <a className="emphasis-link" href={this.props.homeSettings.sectionOneLink}>
                    <u>{this.props.homeSettings.sectionOneLinkText}</u>
                </a>
            </div>);

            sectionTwoContent = (
                <div className="container">
                    <div className="pull-right text-right">
                        <h1 className="mb-2 yellow-text">{this.props.homeSettings.sectionTwoText.split('<br />').map((text, index) => {
                            return index == 0 ? <span>{text}</span> : <span><br />{text}</span>
                        })}</h1>
                        <a className="emphasis-link yellow-text  " href={this.props.homeSettings.sectionTwoLink}>
                            <u>{this.props.homeSettings.sectionTwoLinkText}</u>
                        </a>
                    </div>
                </div>
            );
        }

        return (
            <div>
                <section className="full-page main-banner double-rings-bg base1-bg">
                    <div>
                        {sectionOneContent}
                    </div>
                </section>
                <section className="full-page site-map-banner base2-bg jelly-fish-bg">
                    <div className=" mx-auto text-center">
                        <div>
                            {sectionTwoContent}
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        homeSettings: state.siteData.siteData.homeSettings,
        isLoading: state.siteData.isLoading
    };
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {},
        dispatch
    );
};


const HomeSectionsContainer = connect(mapStateToProps, mapDispatchToProps)(
    HomeSections
);

export default HomeSectionsContainer;


// WEBPACK FOOTER //
// ./src/components/Home/HomeSections.tsx